export const REQUEST = 'elementmatch/REQUEST';
export const SUCCESS = 'elementmatch/SUCCESS';
export const FAILURE = 'elementmatch/FAILURE';

export const GET_SELLERS_SUCCESS = 'elementmatch/GET_SELLERS_SUCCESS';
export const GET_CATEGORIES_SUCCESS = 'elementmatch/GET_CATEGORIES_SUCCESS';
export const GET_ELEMENTS_SUCCESS = 'elementmatch/GET_ELEMENTS_SUCCESS';
export const SAVE_ELEMENT_MATCH_SUCCESS = 'elementmatch/SAVE_ELEMENT_MATCH_SUCCESS';